// frontend/src/App.tsx
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { BrandingProvider } from './core/branding/BrandingContext';
import { SimpleAuthProvider } from './components/auth/SimpleAuthProvider';
import { AppRoutes } from './routes/AppRoutes';
import './styles/globals.css';

function App() {
  return (
    <BrowserRouter>
      <BrandingProvider>
        <SimpleAuthProvider>
          <AppRoutes />
        </SimpleAuthProvider>
      </BrandingProvider>
    </BrowserRouter>
  );
}

export default App;